

export const HOT_TOAST_OBSERVE_DOWNLOAD: any = {
	loading: "Descargando archivo...",
	success: "Descarga completada!",
	error: "No se puede descargar el archivo",
};

export const MENSAJE = {
	INVALID_FORM:
		"Formulario invalido, por favor complete los campos necesarios",
	CONFIRM_CHANGES: "Esta seguro de confirmar cambios",
};

export const MESSAGE_HTML_ERROR_ACCESS = () => {
	return `
		<div class='error-message-access'>
			<h3>Errores de Acceso</h3>
			<ul class='m-0'>
				<li class='mb-1'>El usuario no tiene los permisos</li>
				<li class='mb-1'>La aplicación no tiene una ruta asignada valida</li>
			</ul>
		</div>
	`;
};

export const ACCESS_ERROR_STORAGE_KEY = "core-automatizaciones-access-error";
export const ACCOUNT_SWITCH_STORAGE_KEY =
	"core-automatizaciones-account-switch";

export type AccessNoticeType =
	| "authentication"
	| "session"
	| "accounts"
	| "permissions"
	| "module"
	| "service"
	| "network"
	| "unexpected";

export interface AccessNotice {
	type: AccessNoticeType;
	message: string;
}

export interface AccountSwitchRequest {
	currentEmail: string;
	requestedEmail: string;
	returnUrl: string;
}

export const SESSION_EXPIRED_MESSAGE =
	"Tu sesión expiró o no pudo renovarse automáticamente. Vuelve a iniciar sesión para continuar.";

export const AUTH_ERROR_MESSAGE =
	"No se pudo validar tu sesión. Ingresa nuevamente desde el portal correspondiente.";

export const NO_ACTIVE_SESSION_MESSAGE =
	"No hay una sesión activa. Ingresa desde el portal correspondiente para acceder a esta aplicación.";

export const PORTAL_SESSION_REQUIRED_MESSAGE =
	"Este correo no tiene una sesión activa en el portal. Inicia sesión en el portal primero para acceder.";

export const MULTIPLE_ACCOUNTS_MESSAGE =
	"No se pudo determinar qué cuenta debes usar. Vuelve al portal e ingresa con la cuenta correspondiente.";

export const NO_PERMISSIONS_MESSAGE =
	"Tu cuenta no tiene permisos habilitados para acceder a este módulo.";

export const MODULE_NOT_FOUND_MESSAGE =
	"El módulo solicitado no existe o no está disponible.";

export const INVALID_MODULE_ROUTE_MESSAGE =
	"La ruta solicitada no corresponde a un módulo válido.";

export const AZURE_ACCOUNT_NOT_FOUND_MESSAGE =
	"La cuenta solicitada no existe en Azure o no pertenece a la organización. Verifica el correo o vuelve al portal.";

export const ACCOUNT_SWITCH_UNAVAILABLE_MESSAGE =
	"No se pudo continuar con la cuenta solicitada de forma automática. Vuelve al portal e ingresa con esa cuenta.";

export const REGEX_PATTERN_SITE = /^[A-Za-z]{2}[0-9]{5}$/;
